/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FootfallOverviewItem
 */
export interface FootfallOverviewItem {
    /**
     * 
     * @type {string}
     * @memberof FootfallOverviewItem
     */
    startingFrom: string;
    /**
     * 
     * @type {string}
     * @memberof FootfallOverviewItem
     */
    endingAt: string;
    /**
     * Portion (0-1) of interval within opening hours
     * @type {number}
     * @memberof FootfallOverviewItem
     */
    openedPortion: number;
    /**
     * Bracket set (comma-separated) => Number of visits with given properties
     * @type {{ [key: string]: number; }}
     * @memberof FootfallOverviewItem
     */
    properties: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof FootfallOverviewItem
     */
    numberOfIncoming?: number;
    /**
     * 
     * @type {number}
     * @memberof FootfallOverviewItem
     */
    numberOfOutgoing?: number;
}

export function FootfallOverviewItemFromJSON(json: any): FootfallOverviewItem {
    return FootfallOverviewItemFromJSONTyped(json, false);
}

export function FootfallOverviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FootfallOverviewItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startingFrom': json['starting_from'],
        'endingAt': json['ending_at'],
        'openedPortion': json['opened_portion'],
        'properties': json['properties'],
        'numberOfIncoming': !exists(json, 'number_of_incoming') ? undefined : json['number_of_incoming'],
        'numberOfOutgoing': !exists(json, 'number_of_outgoing') ? undefined : json['number_of_outgoing'],
    };
}

export function FootfallOverviewItemToJSON(value?: FootfallOverviewItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
        'opened_portion': value.openedPortion,
        'properties': value.properties,
        'number_of_incoming': value.numberOfIncoming,
        'number_of_outgoing': value.numberOfOutgoing,
    };
}

